<template>
      <b-modal size="xl" v-model="show_module" @hidden="resetModal" @close="resetModal">
        <b-container fluid>
            <div class="row put_content_right">
                <button class="button put_content_right">Save</button>
            </div>
            <h6>Modal Name and Lesson Name</h6>
            <b-row class="mb-1">
                <b-col sm="4">
      
                    <h6>ID {{current_lesson_modal.id}} <img class="ml-5" width="15" src="../../../assets/images/icons/solid/clock.svg" /> {{current_lesson_modal.duration}}<hr/> </h6>
                    <span> Used by 5 agencies,
                            In 17 programs, and {{current_lesson_modal.modules.length}} Module
                    </span>
                    <h6 class="mt-2">Notes</h6>
                            <textarea class="form-control mb-2" 
                            v-model="current_lesson_modal.notes"
                            v-validate="'required'" 
                            name="description"></textarea>
                    <span>Date</span>
                    <span><p> {{current_lesson_modal.created_at}}</p></span>
                    <span>Date Modified</span>
                    <span><p> 03/01/2021</p></span>
           
               </b-col>
              
                <b-col>
                    <b-tabs v-model="tabIndex" class="column col-12">
                        <b-tab class="white-background" :key="index" v-for="(player, index) in updatePool" :title="player">
                            <!-- <div class="w-25 column"> 
                            --> <b-container class="mb-3 mt-2" fluid>
                                <b-row>
                                     <b-col>
                                        <vue-dropzone class="dropzone-module-small w-25" ref="attachmentsDropzone" id="dropzone1" 
                                        :options="attachmentsDropzoneOptions"
                                        @vdropzone-success="attachmentUploaded">
                                        </vue-dropzone>
                                        	<div class="mt-2 ml-2">
										<button class="button-sme red-content mb-0">	            				
                                             <img width="11" src="../../../assets/images/icons/solid/times_white.svg" />
                                        </button>
                                        <button class="button-sme gray-content mb-0">
                                            <img width="15" src="../../../assets/images/icons/solid/eye_white.svg" />
                                        </button>
                                        <button class="button-sme gray-content mb-0">
                                          <img width="15" src="../../../assets/images/icons/solid/download_white.svg" />
                                        </button>
                                        
                                    </div>
                                     </b-col>
                                     <b-col>
                                    <h6>{{current_lesson_modal.name}}</h6>
                                     </b-col>
                                </b-row>
                              
                                </b-container>
                                
                            <!-- </div> -->
                            <b-container fluid>
                                 <textarea class="form-control mb-2 deneme mt-4" v-model="current_lesson_modal.description"
                                    v-validate="'required'" 
                                    name="description"
                                        ></textarea>
                            </b-container>
                        </b-tab>
                    </b-tabs>
                </b-col>
                
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>
export default {
    props:['modalShow'],
    data: function(){
        return{
            show_module:false,
            tabIndex:0,
            updatePool:["Englist","French","Turksih","Indian","Arabic"],
            current_lesson_modal:{
                name:'',
                id:'',
                description : '',
                notes:'',
                duration:'',
                created_at:'',
                modules:[]
            },
             attachmentsDropzoneOptions: {
                url : this.config.UPLOAD_ATTACHMENT_FILES,
                thumbnailWidth: 50,
                maxFilesize: 500,
                maxFiles : 100,
                addRemoveLinks : true,
                timeout : 300000,
                headers : {
                    'Autrollization' : localStorage.getItem('token')
                }
            },

        }
    },
    created: function(){
        this.show_module = this.modalShow

    },
    methods : {
          resetModal: function(){
            console.log("resetModal")
        },
        /*
        * TODO for future when we close this modal, send event to make modalShow = false on the SMEMainView
        */
        attachmentUploaded : function(file, response){
            // 
            
        },
    }
}

</script>


// WEBPACK FOOTER //
// src/components/sme/SharedViews/LessonCreateView.vue